<template>
  <img
    :src="logoSrc"
    :height="height || undefined"
    class="logo-desktop"
    :alt="logoAlt"
  />
</template>

<script>
// Mixins
import mixinGeral from "@/mixin/mixin-geral";

export default {
  name: 'LogoType',
  mixins: [mixinGeral],
  props: {
    useSymbol: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: null
    },
    /**
     * Força a variante para fundo escuro, independentemente do tema do app.
     * Usado no shell de navegação, que é escuro nos dois temas — sem isso o
     * logotipo preto some sobre o ink.
     */
    onDark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    useDarkVariant() {
      return this.onDark || this.isDark;
    },
    logoSrc() {
      if (this.useSymbol) return this.useDarkVariant ? this.symbolDark : this.symbolLight;

      return this.useDarkVariant ? this.logotypeDark : this.logotypeLight;
    },
    logoAlt() {
      return this.themeName
        ? `Logotipo ${this.themeName}`
        : 'Logotipo';
    }
  }
};
</script>

<style scoped>
</style>